export default __webpack_public_path__ + "static/media/authorization.6f557044.svg";